<modal>
  <span header>{{'Cắt tách cây vải' | lang}} {{good.SKU}} {{'màu' | lang}} {{good.Color}}</span>

  <p>{{(good.Unit == 1 ? 'Số mét còn lại' : 'Số cân còn lại') | lang}}</p>
  <number-input class="w-100 std-border hlf-padding std-border-radius text-center bold text-primary" [value]="good.ActualQuantity - splitted" [decimalPlaces]="1" (change)="setOriginal($event.target)"></number-input>
  <p>{{(good.Unit == 1 ? 'Só mét cắt' : 'Số cân cắt') | lang}}</p>
  <number-input class="w-100 std-border hlf-padding std-border-radius text-center bold text-danger std-margin-bottom" [value]="splitted" [decimalPlaces]="1" (change)="setSplitted($event.target)"></number-input>
  <button [disabled]="!valid" class="bg-primary text-white w-100 std-margin-top" (click)="save()"><i class="fa fa-save"></i><span>{{'Cắt tách cây vải' | lang}}</span></button>
</modal>
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
